// The keys of a list without selection (Sessions, Releases), as small kbd text beside the table
// (docs/brand.md "Keyboard"). lib/keys.ts useRowKeys handles them.
import { useI18n } from '../i18n'

export function RowKeysHint() {
  const { t } = useI18n()
  return (
    <p className="list-hint">
      <kbd translate="no">j</kbd> {t('issues.state.key.next')} · <kbd translate="no">k</kbd>{' '}
      {t('issues.state.key.previous')} · <kbd>↵</kbd> {t('issues.state.key.open')}
    </p>
  )
}
